import React from 'react'
import { useLocation } from 'react-router-dom'
import { UserMenu } from './UserMenu'
import { useAuth } from '@/hooks/useAuth'
import { List } from 'phosphor-react'

interface HeaderProps {
  onToggleSidebar: () => void
  onToggleSidebarCollapse: () => void
}

const pageTitles: Record<string, string> = {
  '/': 'Tableau de bord',
  '/users': 'Utilisateurs',
  '/clients': 'Clients',
  '/logs': "Journaux d'activité",
  '/settings': 'Paramètres',
}

export const Header: React.FC<HeaderProps> = ({ onToggleSidebar, onToggleSidebarCollapse }) => {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) return null

  const pageTitle = pageTitles[location.pathname] || ''

  return (
    <header className="sticky top-0 z-40 bg-white shadow-sm">
      <div className="flex items-center justify-between px-6 py-2">
        <div className="flex items-center gap-3">
          <button
            onClick={onToggleSidebar}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-[var(--color-gray-100)] transition-colors"
            aria-label="Toggle sidebar"
          >
            <List className="w-6 h-6 text-[var(--color-text-primary)]" weight="regular" />
          </button>
          <button
            onClick={onToggleSidebarCollapse}
            className="hidden lg:flex items-center justify-center w-10 h-10 rounded-lg hover:bg-[var(--color-gray-100)] transition-colors"
            aria-label="Toggle sidebar width"
          >
            <List className="w-6 h-6 text-[var(--color-text-primary)]" weight="regular" />
          </button>
          {pageTitle && (
            <h1 className="text-xl font-bold text-[var(--color-text-primary)]">{pageTitle}</h1>
          )}
        </div>
        <div className="flex-1 lg:flex-none lg:ml-auto">
          <div className="flex items-center justify-end">
            <UserMenu user={user} />
          </div>
        </div>
      </div>
    </header>
  )
}
